"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const lodash_1 = __importDefault(require("lodash"));
const react_1 = __importStar(require("react"));
const colors = __importStar(require("../../../assets/styles/colors"));
const hooks_1 = require("../../../store/hooks");
const thresholdSlice_1 = require("../../../store/thresholdSlice");
const thresholdEventHandlers_1 = require("../../../utils/thresholdEventHandlers");
const thresholdGestureHandlers_1 = require("../../../utils/thresholdGestureHandlers");
const thresholdThumbCalculations_1 = require("../../../utils/thresholdThumbCalculations");
const useScreenSizeDetection_1 = __importDefault(require("../../../utils/useScreenSizeDetection"));
const S = __importStar(require("./ThresholdConfigurator.style"));
const maxThresholdDifference = 1;
const ThresholdSlider = ({ isMobileOldStyle, useColorBoxStyle, setErrorMessage, isUniformDistributionButtonVisible, }) => {
    const sliderRef = (0, react_1.useRef)(null);
    const thresholdsState = (0, hooks_1.useAppSelector)(thresholdSlice_1.selectThresholds);
    const sliderWidth = (0, hooks_1.useAppSelector)(thresholdSlice_1.selectSliderWidth);
    const [thresholdValues, setThresholdValues] = (0, react_1.useState)(thresholdsState);
    const [activeInput, setActiveInput] = (0, react_1.useState)(null);
    const [inputValue, setInputValue] = (0, react_1.useState)("");
    const thumbPositions = (0, hooks_1.useAppSelector)((state) => state.threshold.thumbPositions);
    const isMobile = (0, useScreenSizeDetection_1.default)();
    const dispatch = (0, hooks_1.useAppDispatch)();
    const colorsMap = {
        min: colors.green100,
        low: colors.yellow100,
        middle: colors.orange100,
        high: colors.red100,
        max: colors.red100,
    };
    const debouncedSetUserThresholdValues = (0, react_1.useMemo)(() => lodash_1.default.debounce((values) => dispatch((0, thresholdSlice_1.setUserThresholdValues)(values)), 300), [dispatch]);
    (0, react_1.useEffect)(() => {
        if (!lodash_1.default.isEqual(thresholdsState, thresholdValues)) {
            setThresholdValues(thresholdsState);
        }
    }, [thresholdsState]);
    (0, react_1.useEffect)(() => {
        if (!lodash_1.default.isEqual(thresholdsState, thresholdValues)) {
            debouncedSetUserThresholdValues(thresholdValues);
        }
    }, [thresholdValues, debouncedSetUserThresholdValues]);
    const updateSliderWidthHandler = (0, react_1.useCallback)(() => {
        if (sliderRef.current) {
            const computedStyle = getComputedStyle(sliderRef.current);
            const width = sliderRef.current.clientWidth -
                parseFloat(computedStyle.paddingLeft) -
                parseFloat(computedStyle.paddingRight);
            dispatch((0, thresholdSlice_1.updateSliderWidth)(width));
        }
    }, [dispatch]);
    (0, react_1.useLayoutEffect)(() => {
        updateSliderWidthHandler();
        const handleResize = () => {
            setTimeout(updateSliderWidthHandler, 100);
        };
        window.addEventListener("resize", handleResize);
        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, [updateSliderWidthHandler, isUniformDistributionButtonVisible]);
    const { handleInputBlur, handleInputFocus, handleInputKeyDown, handleOutsideClick, handleSliderClick, } = (0, thresholdEventHandlers_1.useThresholdHandlers)(setThresholdValues, setInputValue, setActiveInput, setErrorMessage, thresholdValues, sliderRef, activeInput, inputValue, sliderWidth);
    (0, react_1.useEffect)(() => {
        document.addEventListener("click", handleOutsideClick);
        return () => {
            document.removeEventListener("click", handleOutsideClick);
        };
    }, [handleOutsideClick]);
    const updateThumbPositionsHandler = (0, react_1.useCallback)(() => {
        if (sliderRef.current) {
            const { min, low, middle, high, max } = thresholdValues;
            const lowThumb = (0, thresholdThumbCalculations_1.calculateThumbPosition)(low, min, max, sliderWidth, isMobile);
            const middleThumb = (0, thresholdThumbCalculations_1.calculateThumbPosition)(middle, min, max, sliderWidth, isMobile);
            const highThumb = (0, thresholdThumbCalculations_1.calculateThumbPosition)(high, min, max, sliderWidth, isMobile);
            const newThumbPositions = {
                low: lowThumb,
                middle: middleThumb,
                high: highThumb,
            };
            dispatch((0, thresholdSlice_1.updateThumbPositions)(newThumbPositions));
        }
    }, [thresholdValues, sliderWidth, isMobile, dispatch]);
    (0, react_1.useLayoutEffect)(() => {
        updateThumbPositionsHandler();
    }, [thresholdValues, sliderWidth, updateThumbPositionsHandler]);
    const { min, max } = thresholdValues, thumbs = __rest(thresholdValues, ["min", "max"]);
    const thumbData = Object.entries(thumbs);
    const renderNumberInput = (thresholdKey, value, positionStyle = {}) => (react_1.default.createElement(S.NumberInput, { inputMode: "numeric", type: "number", value: activeInput === thresholdKey ? inputValue : value.toString(), onFocus: () => handleInputFocus(thresholdKey), onBlur: () => handleInputBlur(thresholdKey, inputValue), style: Object.assign(Object.assign({}, positionStyle), { zIndex: 5, marginLeft: thresholdKey === "min" ? "-15px" : value === max ? "0px" : "-15px", left: thresholdKey === "max"
                ? "auto"
                : `${(0, thresholdThumbCalculations_1.calculateThumbPosition)(value, min, max, sliderWidth, isMobile)}px`, right: thresholdKey === "max" ? "-20px" : "auto" }), onChange: (e) => setInputValue(e.target.value), onTouchStart: thresholdKey === "min" || thresholdKey === "max"
            ? undefined
            : (event) => (0, thresholdGestureHandlers_1.handleTouchStart)(thresholdKey, thresholdValues, sliderWidth, setThresholdValues, setInputValue, setErrorMessage)({ touches: [{ clientX: event.touches[0].clientX }] }), onMouseDown: thresholdKey === "min" || thresholdKey === "max"
            ? undefined
            : (0, thresholdGestureHandlers_1.handleMouseDown)(thresholdKey, thresholdValues, sliderWidth, setThresholdValues, setInputValue, setErrorMessage), onKeyDown: thresholdKey === "min" || thresholdKey === "max"
            ? undefined
            : handleInputKeyDown(thresholdKey), "$isLast": thresholdKey === "max", "$isMin": thresholdKey === "min" }));
    const renderDefaultSlider = () => (react_1.default.createElement(react_1.default.Fragment, null,
        !isMobileOldStyle && renderNumberInput("min", min),
        thumbData.map(([thresholdKey, value]) => (react_1.default.createElement(react_1.default.Fragment, { key: thresholdKey },
            react_1.default.createElement(S.RangeInput, { min: min, max: max, "$firstThumbPos": thumbPositions.low, "$secondThumbPos": thumbPositions.middle, "$thirdThumbPos": thumbPositions.high, "$sliderWidth": sliderWidth, type: "range", value: value, readOnly: true, "$isMobileOldStyle": isMobileOldStyle }),
            !isMobileOldStyle &&
                renderNumberInput(thresholdKey, value, {
                    zIndex: 5,
                    marginLeft: value === min || value === max - maxThresholdDifference
                        ? "0px"
                        : "-15px",
                    left: value === max || value === max - maxThresholdDifference
                        ? "auto"
                        : `${(0, thresholdThumbCalculations_1.calculateThumbPosition)(value, min, max, sliderWidth, isMobile)}px`,
                    right: value === max || value === max - maxThresholdDifference
                        ? "0px"
                        : "auto",
                })))),
        !isMobileOldStyle && renderNumberInput("max", max),
        isMobileOldStyle &&
            thumbData.map(([thresholdKey, value]) => (react_1.default.createElement(react_1.default.Fragment, { key: thresholdKey },
                react_1.default.createElement(S.OldStyleSliderHandles, { style: {
                        left: `${(0, thresholdThumbCalculations_1.calculateThumbPosition)(value, min, max, sliderWidth, isMobile)}px`,
                    }, onTouchStart: thresholdKey === "min" || thresholdKey === "max"
                        ? undefined
                        : (event) => (0, thresholdGestureHandlers_1.handleTouchStart)(thresholdKey, thresholdValues, sliderWidth, setThresholdValues, setInputValue, setErrorMessage)({ touches: [{ clientX: event.touches[0].clientX }] }), onMouseDown: thresholdKey === "min" || thresholdKey === "max"
                        ? undefined
                        : (0, thresholdGestureHandlers_1.handleMouseDown)(thresholdKey, thresholdValues, sliderWidth, setThresholdValues, setInputValue, setErrorMessage), onKeyDown: handleInputKeyDown(thresholdKey) },
                    react_1.default.createElement(S.OldStyleSliderHandle, null),
                    react_1.default.createElement(S.OldStyleSliderText, null, value)))))));
    const renderColorBoxSlider = () => (react_1.default.createElement(S.StaticMobileSliderContainer, null,
        react_1.default.createElement(S.ColorBoxNumberInput, { inputMode: "numeric", type: "number", step: 1, value: activeInput === "min" ? inputValue : min.toString(), onFocus: () => handleInputFocus("min"), onBlur: () => handleInputBlur("min", inputValue), onChange: (e) => setInputValue(e.target.value), onKeyDown: handleInputKeyDown("min") }),
        react_1.default.createElement(S.ColorBox, { style: { background: colorsMap["min"] } }),
        thumbData.map(([thresholdKey, value]) => (react_1.default.createElement(react_1.default.Fragment, { key: thresholdKey },
            react_1.default.createElement(S.ColorBoxNumberInput, { inputMode: "numeric", type: "number", step: 1, value: activeInput === thresholdKey ? inputValue : value.toString(), onFocus: () => handleInputFocus(thresholdKey), onBlur: () => handleInputBlur(thresholdKey, inputValue), onChange: (e) => setInputValue(e.target.value), onKeyDown: handleInputKeyDown(thresholdKey) }),
            react_1.default.createElement(S.ColorBox, { style: { background: colorsMap[thresholdKey] } })))),
        react_1.default.createElement(S.ColorBoxNumberInput, { inputMode: "numeric", type: "number", step: 5, value: activeInput === "max" ? inputValue : max.toString(), onFocus: () => handleInputFocus("max"), onBlur: () => handleInputBlur("max", inputValue), onChange: (e) => setInputValue(e.target.value), onKeyDown: handleInputKeyDown("max") })));
    return (react_1.default.createElement(S.InputContainer, { ref: sliderRef, onClick: (event) => !useColorBoxStyle && handleSliderClick(event), onTouchStart: (event) => !useColorBoxStyle && handleSliderClick(event), "$isMobileOldStyle": isMobileOldStyle, "$useColorBoxStyle": useColorBoxStyle }, useColorBoxStyle ? renderColorBoxSlider() : renderDefaultSlider()));
};
exports.default = ThresholdSlider;
